import { Alert, Button, Stack } from "@mui/material";
import { FormEvent, useState } from "react";

import Input, { InputType } from "../../components/forms/Input";
import Main from "../../components/layout/Main";
import MetaData from "../../components/MetaData";
import useFetch from "../../hooks/useFetch";

const SEO_TITLE = "Feedback";

const SUCCESS_OPTIONS = [
  { label: "Ja", value: "true" },
  { label: "Nee", value: "false" },
];

const Show = () => {
  const params = new URLSearchParams(window.location.search);
  const [success, setSuccess] = useState(params.get("button") === "ja");
  const [feedback, setFeedback] = useState("");
  const [put, { error, loading, submitted }] = useFetch(window.location.href, {
    method: "PUT",
  });

  const handleSubmit = (e: FormEvent) => {
    e?.preventDefault();
    put({
      feedback: {
        success,
        feedback,
      },
    });
  };

  if (submitted) {
    return (
      <Main>
        <MetaData title={SEO_TITLE} />
        <p>Bedankt voor je feedback!</p>
      </Main>
    );
  }

  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <form onSubmit={handleSubmit}>
        <p>We horen graag hoe deze website is bevallen!</p>
        <Stack spacing={1}>
          <Input
            required
            label="Is het goed gegaan met het aanvragen van de vergoeding?"
            name="success"
            options={SUCCESS_OPTIONS}
            type={InputType.RadioGroup}
            value={success.toString()}
            onChange={(e) => setSuccess(e.target.value === "true")}
          />
          <Input
            autoFocus
            required
            label={
              success
                ? "Fijn dat het goed is gegaan! Heb je feedback voor ons?"
                : "Wat ging er mis? Heb je feedback voor ons?"
            }
            name="feedback"
            placeholder="Feedback"
            type={InputType.TextArea}
            value={feedback}
            onChange={(e) => setFeedback(e.target.value as string)}
          />
        </Stack>
        {error && (
          <Alert severity="error" sx={{ marginTop: "1em" }}>
            {error}
          </Alert>
        )}
        <Stack direction="row" justifyContent="end">
          <Button
            loading={loading}
            sx={{ marginTop: "1em" }}
            type="submit"
            variant="contained"
          >
            Verstuur
          </Button>
        </Stack>
      </form>
    </Main>
  );
};

export default Show;
